import { useRef } from 'react';

/** [was] without what has closed, and with what has just opened at its end; [was] itself while
 *  nothing changed. */
export function nextOpenOrder(was: readonly string[], open: Readonly<Record<string, boolean>>): readonly string[] {
  const kept = was.filter((k) => open[k]);
  const opened = Object.keys(open).filter((k) => open[k] && !kept.includes(k));
  return kept.length === was.length && opened.length === 0 ? was : [...kept, ...opened];
}

/** The surfaces a page has open, in the order they opened: Esc closes the last first. */
export function useOpenOrder(open: Readonly<Record<string, boolean>>): readonly string[] {
  const order = useRef<readonly string[]>([]);
  order.current = nextOpenOrder(order.current, open);
  return order.current;
}
